import { PlayIcon } from '@phosphor-icons/react';

import { Heading } from '@shared/ui';
import { DashboardContainer } from '@shared/ui/layouts';

import { PracticeViewDash } from './PracticeViewDash';
import { PracticeViewMenu } from './PracticeViewMenu';

interface PracticeHeroProps {
  title: string;
  subtitle: string;
  description: string;
  audioGuide: string;
  audioDuration: string;
}

export const PracticeHero = ({
  title,
  description,
  audioGuide,
  audioDuration,
}: PracticeHeroProps) => {
  return (
    <div className="relative min-h-56 bg-blue-600 pt-24">
      <div
        className="absolute inset-0 opacity-15 mix-blend-overlay brightness-110"
        style={{
          backgroundImage: 'url(/src/shared/assets/images/background_icon.png)',
          backgroundSize: 'contain',
          backgroundPosition: 'right',
          backgroundRepeat: 'no-repeat',
        }}
      />

      <DashboardContainer>
        <div className="text-white">
          <Heading tag="h1" size="3xl" className="mb-4 text-white">
            {title}
          </Heading>
          <p className="mb-6 max-w-prose text-sm text-balance opacity-95">{description}</p>

          <div className="flex justify-between">
            <button
              className="
                flex items-center gap-4 rounded-full border border-white/20 bg-white/15 p-1
                backdrop-blur-md transition-colors
                hover:bg-white/25
              "
            >
              <div
                className="
                  flex size-7 items-center justify-center rounded-full bg-white text-[#155DFC]
                "
              >
                <PlayIcon className="size-3.5" />
              </div>
              <span className="text-sm font-medium text-white">{audioGuide}</span>
              <span className="text-sm text-white/70">{audioDuration}</span>
            </button>

            <div className="flex items-center gap-2">
              <PracticeViewMenu />
              <PracticeViewDash />
            </div>
          </div>
        </div>
      </DashboardContainer>
    </div>
  );
};
